import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const RequestsRequest = async() => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('token');
        
    const res = await AxiosInstance.get('/requests', {
      headers: {
        'Authorization': `Bearer ${token}`
        }
    });

    return res;
  } catch (error) {
    console.error('error in request:', error);
    throw error;
  }     
};

export default RequestsRequest;